export default "__VITE_ASSET__0b624bc1__"